import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AllRepaymentListPage2UI from './AllRepaymentListPage2UI.js'

class AllRepaymentListPage2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountList: null,
      filteredAccountList: null,
      prepaymentAccountList: null,
      totals: null,
      totalLoans: null,
      totalNonRFLoans: null,
      totalRFLoans: null,
      checked: false,
      downloadSubmitted: null,
      view: false,
    }
  }

  render() {
    return (
      <AllRepaymentListPage2UI
        context={this.props.context}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        filteredAccountList={this.state.filteredAccountList}
        prepaymentAccountList={this.state.prepaymentAccountList}
        onRefreshClick={this.onRefreshClick}
        totals={this.state.totals}
        totalLoans={this.state.totalLoans}
        totalNonRFLoans={this.state.totalNonRFLoans}
        totalRFLoans={this.state.totalRFLoans}
        checked={this.state.checked}
        onShowDetailsChange={this.onShowDetailsChange}
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        type={this.props.match.params.type}
        // filter
        onDsraIntClick={this.onDsraIntClick}
        onDefaultIntClick={this.onDefaultIntClick}
        onShortfallClick={this.onShortfallClick}
        onPrepaidClick={this.onPrepaidClick}
        onClearFilter={this.onClearFilter}
        view={this.state.view}
        onViewChange={this.onViewChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    /*
    let cacheManager = new CacheManager({
      resource: `dummy`,
      cacheKey: CacheKeys.AccountRepaymentsChecked()
    })
    let checkedObj = cacheManager.getObjectFromCache()
    if (checkedObj)
      this.setState({ checked: checkedObj.checked })
    */
    console.log('AllRepaymentListPage2SF componentDidMount 1')
    this.getRepayments(context)
  }

  componentDidUpdate(prevProps) {
    console.log('AllRepaymentListPage2SF componentDidUpdate 1')
    if (this.props.match.params.type == prevProps.match.params.type &&
      this.props.match.params.year == prevProps.match.params.year &&
      this.props.match.params.month == prevProps.match.params.month
    )
      return
    console.log('AllRepaymentListPage2SF componentDidUpdate 2')
    this.getRepayments(this.props.context)
  }

  getRepayments(context) {
    console.log(this.props.match.params.type, this.props.match.params.year, this.props.match.params.month)
    console.log(CacheKeys.AllRepayments(this.props.match.params.type, this.props.match.params.year, this.props.match.params.month))

    this.setState({ accountList: null, totals: null, errorList: null })

    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/repayments`,
      cacheKey: CacheKeys.AllRepayments(this.props.match.params.type, this.props.match.params.year, this.props.match.params.month),
      callback: this.getRepaymentsCallback,
      ttlInSecs: 600
    })
    if (!this.props.match.params.type || !this.props.match.params.year || !this.props.match.params.month)
      cacheManager.getObject2(context, {}, {})
    else
      cacheManager.getObject2(context, {}, {
        filter: this.props.match.params.type,
        year: this.props.match.params.year,
        month: this.props.match.params.month,
      })
  }

  getRepaymentsCallback = (response) => {
    let totalLoans = 0;
    let totalRFLoans = 0;
    let totalNonRFLoans = 0;

    response.accountRepaymentList.forEach((acc) => {
      acc.repaymentList.forEach((repayment) => {
        totalLoans += 1;
        if (repayment.loanType === "Inv+Disc") {
          totalRFLoans += 1;
        } else {
          totalNonRFLoans += 1;
        }
      });
    });

    this.setState({
      errorList: response.errorList,
      accountList: response.accountRepaymentList,
      prepaymentAccountList: response.accountPrepaymentList,
      filteredAccountList: response.accountRepaymentList,
      totals: response,
      totalLoans: totalLoans,
      totalRFLoans: totalRFLoans,
      totalNonRFLoans: totalNonRFLoans
    })
  }

  onDsraIntClick = () => {
    let filteredList = this.state.accountList.filter(a => a.totalDSRADipInterestF5 !== '0.00')
    this.setState({ filteredAccountList: filteredList })
  }

  onDefaultIntClick = () => {
    let filteredList = this.state.accountList.filter(a => a.totalDefaultInterestF5 !== '0.00')
    this.setState({ filteredAccountList: filteredList })
  }

  onClearFilter = () => {
    this.setState({ filteredAccountList: this.state.accountList })
  }

  onShortfallClick = () => {
    let filteredList = this.state.accountList.filter(a => a.totalShortfallF5 !== '0.00')
    this.setState({ filteredAccountList: filteredList })
  }

  onPrepaidClick = () => {
    let filteredList = this.state.accountList.filter(a => a.totalPrePaidAmountF5 !== '0.00')
    this.setState({ filteredAccountList: filteredList })
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onViewChange = () => {
    let view2 = !this.state.view
    CacheManager.setObject(CacheKeys.AccountRepaymentsChecked(), { view: view2 })
    this.setState({
      view: view2
    })
  }

  onDownloadClick = () => {
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true
    })
    let type = this.props.match.params.type || ''
    let year = this.props.match.params.year || ''
    let month = this.props.match.params.month || ''
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/loans/repayments/excel/fileDownloadSignedUrl?filter=${type}&year=${year}&month=${month}`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AllRepayments(this.props.match.params.type, this.props.match.params.year, this.props.match.params.month))
    this.setState({ accountList: null, errorList: null, totals: null }, () => {
      this.getRepayments(this.props.context)
    })
  }

}

export default withRouter(AllRepaymentListPage2SF)
